<template>
  <div>
    <div class="row" style="height: 60px"></div>
    <div class="row titleRow">
      <div class="col">
        <h1>{{$t('endStep.title')}}</h1>
      </div>
    </div>
    <div class="row separatedRow">
      <div class="col">
        <a href="#" @click="createPDF(contractName)" style="float: left;">{{$t('endStep.downloadContract')}}</a>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <a href="#" @click="createPDF(mandatName)" style="float: left;">{{$t('endStep.downloadAutorisationPrel')}}</a>
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-3 overFooter">
        <button type="submit" class="btn btn-primary bg-color alignRight" @click="saveForm()">
          {{$t('general.signLater')}}
        </button>
      </div>
      <div class="col-2 overFooter">
        <button type="submit" class="btn btn-primary bg-color alignRight" @click="goToCashRegister()">
          {{$t('general.finalize')}}
        </button>
      </div>
    </div>
    <pulse-loader :loading="isPdfRendering"></pulse-loader>
  </div>
</template>
<script>
import TemplateContract from '../../static/config/templateContract.json';
import TemplateAutorisationPrel from '../../static/config/templateAutorisationPrel.json';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

var base64Img = require('base64-img-promise');

/*
      Cette fonction permet d'ajouter une période à une date donnée.
      Une période s'exprime ainsi : duration + period
        Duration : Durée à rajouter
        Period: semaine, mois ou année (week, month, year)

      Le paramètre isEndDate si égale à true permet de retirer un jour à la nouvelle date. (Date de fin est une journée avant l'anniversaire de la date de début)

      @params
      inputFormat : String ('YYYY-MM-DD')
      duration : int
      period : String ('week', 'month', 'year')
      isEndDate : boolean
       */
function convertDate (inputFormat, duration, period, isEndDate) { // Source : https://stackoverflow.com/questions/13459866/javascript-change-date-into-format-of-dd-mm-yyyy
  function pad (s) {
    return (s < 10) ? '0' + s : s;
  }

  var d = new Date(inputFormat);

  duration = parseInt(duration); // On s'assure que la durée est un int

  switch (period) {
    case 'week':
      d.setDate(d.getDate() + (duration * 7));
      break;
    case 'month':
      d.setMonth(d.getMonth() + duration);
      break;
    case 'year':
      d.setMonth(d.getMonth() + (duration * 12));
      break;
  }
  if (isEndDate) {
    d.setDate(d.getDate() - 1);
  }
  return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
}

export default {
  name: 'end-step',
  components: {
    'pulse-loader': PulseLoader
  },
  data () {
    return {
      isPdfRendering: false,
      club: {},
      // contratSepa: null,
      idj: null,
      bic: null,
      rum: null,
      idrib: null,
      contractName: '',
      mandatName: '',
      templateContract: TemplateContract.template,
      templateAutorisationPrel: TemplateAutorisationPrel.template,
      optHtml2Pdf: {
        margin: 0.2,
        filename: '',
        image: {type: 'png', quality: 1},
        html2canvas: {dpi: 300, letterRendering: true},
        jsPDF: {unit: 'in', format: 'letter', orientation: 'portrait'}
      }
    };
  },
  activated: function () {
    // On crée une chaine comprenant toutes les infos du formulaire non enregistrées pour les afficher sur la fiche membre dans le champ info_admin
    let infosAdmin = this.getInfoAdmin();

    // On enregistre le membre dans Deciplus en tant que PROSPECT ou on update si idj !== nul
    let dataMember = this.getDataMember(infosAdmin);
    let dataRib = {
      'memberName': this.$store.state.form.resultJson.finalUserInfos.bank.bankFirstname + ' ' + this.$store.state.form.resultJson.finalUserInfos.bank.bankLastname,
      'iban': this.$store.state.form.resultJson.finalUserInfos.bank.bankIban,
      'bic': this.$store.state.form.resultJson.finalUserInfos.bank.bankBic,
      'bankName': this.$store.state.form.resultJson.finalUserInfos.bank.bankName,
      'zone': this.$store.state.form.resultJson.finalUserInfos.subscription.subscriptionClub
    };

    this.contractName = this.generateFileName(dataMember, this.$t('endStep.contract'));
    this.mandatName = this.generateFileName(dataMember, this.$t('endStep.prel'));

    let promiseApiMember = null;
    let promiseApiBank = null;
    if (this.idj === null) { // Membre jamais créé ==> on appelle route API POST
      promiseApiMember = this.$http.post('member', dataMember);
    } else { // Membre déjà inséré en bdd ==> on appelle la route API PUT
      dataMember['id'] = this.idj;
      promiseApiMember = this.$http.put('member', dataMember);
    }
    if (promiseApiMember !== null) {
      promiseApiMember.then((resp) => {
        if (resp.data.errno !== undefined) {
          this.$notify({
            type: 'error',
            title: this.$t('general.errorApi.generalTitle'),
            text: resp.data.errormsg
          });
        } else {
          this.idj = resp.data.response.id;
          this.prefillTemplates().then((resp) => {
            if (this.$parent.$refs.topProgressBar.getProgress() === 0) {
              this.uploadContrat();
            }
          });
          // On enregistre ces informations bancaires ou on update si idrib !== null
          if (this.idj != null && this.$store.state.form.resultJson.finalUserInfos.bank.bankIban != null && this.$store.state.form.resultJson.finalUserInfos.bank.bankFirstname != null && this.$store.state.form.resultJson.finalUserInfos.bank.bankLastname != null && this.$store.state.form.resultJson.finalUserInfos.bank.bankName != null) {
            dataRib['memberId'] = this.idj;

            if (this.idrib === null) { // RIB jamais créé ==> on appelle route API POST
              promiseApiBank = this.$http.post('member/bank/' + this.idj, dataRib);
            } else { // RIB déjà inséré en bdd ==> on appelle la route API PUT
              dataRib['id'] = this.idrib;
              promiseApiBank = this.$http.put('member/bank/' + this.idj, dataRib);
            }
            if (promiseApiBank !== null) {
              promiseApiBank.then((resp) => {
                if (resp.data.errno !== undefined) {
                  this.$notify({
                    type: 'error',
                    title: this.$t('general.errorApi.generalTitle'),
                    text: resp.data.errormsg
                  });
                } else {
                  this.idrib = resp.data.response.id;
                  this.rum = resp.data.response.rum;
                  this.bic = resp.data.response.bic;
                }
                // eslint-disable-next-line
                }).catch((err) => {
                this.$sentry.captureExceptionWithTags(err, {}, this.$options.name, 'activated');
                this.$notify({
                  type: 'error',
                  title: this.$t('general.errorApi.generalTitle'),
                  text: this.$t('general.errorApi.addRib.errormsg')
                });
              });
            }
          }
        }
        // eslint-disable-next-line
        }).catch((err) => {
        this.$sentry.captureExceptionWithTags(err, {}, this.$options.name, 'activated');
        this.$notify({
          type: 'error',
          title: this.$t('general.errorApi.generalTitle'),
          text: this.$t('general.errorApi.addMember.errormsg')
        });
      });
    }
  },
  methods: {
    getInfoAdmin: function () {
      let infosAdmin = 'Partner+ \n' +
          this.formatAdminInfos(this.$t('endStep.adminInfos.date'), convertDate(new Date())) +
          this.formatAdminInfos(this.$t('endStep.adminInfos.origin'), this.$t('knowUs.' + this.$store.state.form.resultJson.knowUs.who)) +
          this.formatAdminInfos(this.$t('endStep.adminInfos.goalSince'), this.$t('knowUs.wishTime.' + this.$store.state.form.resultJson.knowUs.fitnessWish));
      if (this.$store.state.form.resultJson.userInfos.activity !== '') {
        infosAdmin += this.formatAdminInfos(this.$t('endStep.adminInfos.praticedActivity'), this.$store.state.form.resultJson.userInfos.activity);
      }
      if (this.$store.state.form.resultJson.userInfos.clubName !== '') {
        infosAdmin += this.formatAdminInfos(this.$t('endStep.adminInfos.lastClub'), this.$store.state.form.resultJson.userInfos.clubName);
      }
      if (this.$store.state.config.activeSurprise) {
        infosAdmin += this.formatAdminInfos(this.$t('endStep.adminInfos.surprise'), this.$store.state.form.resultJson.userInfos.surprise ? this.$t('general.yes') : this.$t('general.no'));
      }
      infosAdmin += this.formatAdminInfos(this.$t('endStep.adminInfos.goal'), this.$t('target.' + this.$store.state.form.resultJson.target.key));
      switch (this.$store.state.form.resultJson.target.component) {
        case 'TargetBodybuilding':
          infosAdmin +=
              this.formatAdminInfos(this.$t('endStep.adminInfos.bodyParts'), this.stringifyArray(this.$store.state.form.resultJson.targetBodybuilding.targetBodybuildingList, 'targetBodybuilding.')) +
              this.formatAdminInfos(this.$t('endStep.adminInfos.programChangeSensitivity'), this.$store.state.form.resultJson.targetBodybuilding.sensibleChangeInProgram ? this.$t('general.yes') : this.$t('general.no'));
          break;
        case 'TargetFitness':
          infosAdmin +=
              this.formatAdminInfos(this.$t('endStep.adminInfos.trainingField'), this.stringifyArray(this.$store.state.form.resultJson.targetFitness.targetFitnessList, 'targetFitness.')) +
              this.formatAdminInfos(this.$t('endStep.adminInfos.actualForm'), this.$store.state.form.resultJson.targetFitness.actualForm + '/10');
          break;
        case 'TargetWeightloss':
          infosAdmin +=
              this.formatAdminInfos(this.$t('endStep.adminInfos.targetWeight'), this.$store.state.form.resultJson.targetWeightloss.targetWeight + this.$store.state.config.mainconfig.weight);
          break;
        case 'TargetZen':
          infosAdmin +=
              this.formatAdminInfos(this.$t('endStep.adminInfos.trainingField'), this.stringifyArray(this.$store.state.form.resultJson.targetZen.targetZenList, 'targetZen.')) +
              this.formatAdminInfos(this.$t('endStep.adminInfos.stressDegree'), this.$store.state.form.resultJson.targetZen.stressIntensity + '/10') +
              this.formatAdminInfos(this.$t('endStep.adminInfos.supportWay'), this.$t('targetZen.care.' + this.$store.state.form.resultJson.targetZen.care));
          break;
      }
      infosAdmin +=
          this.formatAdminInfos(this.$t('endStep.adminInfos.howManyTimes'), this.$t('howManyTimes.' + this.$store.state.form.resultJson.howManyTimes.frequency)) +
          this.formatAdminInfos(this.$t('endStep.adminInfos.howLong'), this.$store.state.form.resultJson.howManyTimes.rateTime !== 'allTime' ? this.$store.state.form.resultJson.howManyTimes.rateTime + ' ' + this.$t('howManyTimes.minutes') : this.$t('howManyTimes.' + this.$store.state.form.resultJson.howManyTimes.rateTime)) +
          this.formatAdminInfos(this.$t('endStep.adminInfos.targetLevel'), this.$t('whatLevel.' + this.$store.state.form.resultJson.whatLevel)) +
          this.formatAdminInfos(this.$t('endStep.adminInfos.followUpLevel'), this.$t('followUp.' + this.$store.state.form.resultJson.choiceCriteria.followUp)) +
          this.formatAdminInfos(this.$t('endStep.adminInfos.choiceCriteria'), this.stringifyArray(this.$store.state.form.resultJson.choiceCriteria.choiceList, 'choiceCriteria.'));

      return infosAdmin;
    },
    getDataMember: function (infoAdmin) {
      let dataMember = {
        'categoryId': 1, // Catégorie de membre prospect
        'surname': this.$store.state.form.resultJson.finalUserInfos.personal.lastname,
        'name': this.$store.state.form.resultJson.finalUserInfos.personal.firstname,
        'birthdate': this.$store.state.form.resultJson.finalUserInfos.personal.birthDate,
        'email': this.$store.state.form.resultJson.finalUserInfos.personal.email,
        'phoneNumber': this.$store.state.form.resultJson.finalUserInfos.personal.phone,
        'gender': this.$store.state.form.resultJson.userInfos.gender,
        'addressLine1': this.$store.state.form.resultJson.finalUserInfos.personal.adress,
        'postalCode': this.$store.state.form.resultJson.finalUserInfos.personal.postal,
        'city': this.$store.state.form.resultJson.finalUserInfos.personal.city,
        'zoneId': this.$store.state.form.resultJson.finalUserInfos.subscription.subscriptionClub,
        'info_admin': infoAdmin,
        'userId': this.$store.state.form.resultJson.advisor.id,
        'creatorUserId': this.$store.state.form.resultJson.advisor.id
      };
      return dataMember;
    },

    findOptionById: function (id) {
      let returnOption = false;
      this.$store.state.config.options.forEach(function (option) {
        if (option.id === id) {
          returnOption = option;
        }
      });
      return returnOption;
    },
    formatTemplate: function (name) {
      switch (name) {
        case this.contractName:
          return this.formatTemplateContract();
        case this.mandatName:
          return this.formatTemplateAutorisationPrel();
      }
    },
    formatTemplateContract: function () {
      // On récupère les options comprises dans la presta
      let defaultOptions = this.$store.state.form.resultJson.offer.selectedOffer.options;
      let listDefaultOptions = '';
      defaultOptions.forEach(function (option) {
        if (option.active === true) {
          listDefaultOptions += this.findOptionById(option.id).name + ', ';
        }
      }, this);
      listDefaultOptions = listDefaultOptions.substr(0, listDefaultOptions.length - 2);

      // On récupère les options supplémentaires
      let moreOptions = this.$store.state.form.resultJson.moreOptions.options;
      let listSelectedOptions = '';
      moreOptions.forEach(function (option) {
        listSelectedOptions += option.name + ', ';
      });
      listSelectedOptions = listSelectedOptions.substr(0, listSelectedOptions.length - 2);

      // On calcule la date de fin de presta
      let dateFinPresta = null;
      if (this.$store.state.form.resultJson.offer.commitmentChoice !== undefined) {
        dateFinPresta = convertDate(this.$store.state.form.resultJson.finalUserInfos.subscription.subscriptionStartDate, this.$store.state.form.resultJson.offer.commitmentChoice, 'month', true);
      } else if (this.$store.state.form.resultJson.offer.selectedOffer.commitment !== undefined) {
        dateFinPresta = convertDate(this.$store.state.form.resultJson.finalUserInfos.subscription.subscriptionStartDate, this.$store.state.form.resultJson.offer.selectedOffer.commitment.duration, this.$store.state.form.resultJson.offer.selectedOffer.commitment.period, true);
      }

      var mapDatas = {
        '#NOMJOUEUR#': this.$store.state.form.resultJson.finalUserInfos.personal.lastname,
        '#PRENOMJOUEUR#': this.$store.state.form.resultJson.finalUserInfos.personal.firstname,
        '#ADRJOUEUR#': this.$store.state.form.resultJson.finalUserInfos.personal.adress !== null ? this.$store.state.form.resultJson.finalUserInfos.personal.adress : '',
        '#CPJOUEUR#': this.$store.state.form.resultJson.finalUserInfos.personal.postal !== null ? this.$store.state.form.resultJson.finalUserInfos.personal.postal : '',
        '#VILLEJOUEUR#': this.$store.state.form.resultJson.finalUserInfos.personal.city !== null ? this.$store.state.form.resultJson.finalUserInfos.personal.city : '',
        '#EMAILJOUEUR#': this.$store.state.form.resultJson.finalUserInfos.personal.email,
        '#TELJOUEUR#': this.$store.state.form.resultJson.finalUserInfos.personal.phone !== null ? this.$store.state.form.resultJson.finalUserInfos.personal.phone : '',
        '#NOMPRESTA#': this.$store.state.form.resultJson.offer.selectedOffer.name,
        '#OPTPRESTA#': listDefaultOptions,
        '#DEBUTPRESTA#': convertDate(this.$store.state.form.resultJson.finalUserInfos.subscription.subscriptionStartDate, 0, 0, false),
        '#FINPRESTA#': (dateFinPresta !== null) ? dateFinPresta : '',
        '#PRIXPARSEMAINE#': this.$store.state.form.resultJson.moreOptions.totalOfferPrice + this.$store.state.config.mainconfig.currency,
        '#PRIXIMMEDIAT#': this.$store.state.form.resultJson.offer.selectedOffer.initialPrice + this.$store.state.config.mainconfig.currency,
        '#NOMCLUB#': this.club.clubName !== null ? this.club.clubName : '',
        '#ADRCLUB#': this.club.adr1 !== null ? this.club.adr1 : '',
        '#CPCLUB#': this.club.postalCode !== null ? this.club.postalCode : '',
        '#VILLECLUB#': this.club.city !== null ? this.club.city : '',
        '#LOGOCLUB#': this.club.imageclub !== null ? this.club.imageclub + '<br /><br />' : '',
        '#LISTEOPTIONS#': (listSelectedOptions !== '') ? this.$t('endStep.activity') + ' : <b>' + listSelectedOptions + '</b><br />' : '',
        '#CLAUSECLUB#': this.$store.state.config.cgv,
        '#NOMCOMMERCIAL#': this.$store.state.form.resultJson.advisor.name,
        '#NOMPARRAIN#': (this.$store.state.form.resultJson.userInfos.sponsorFirstname !== '' && this.$store.state.form.resultJson.userInfos.sponsorLastname !== '') ? this.$t('endStep.mandatary') + ' : ' + this.$store.state.form.resultJson.userInfos.sponsorFirstname + ' ' + this.$store.state.form.resultJson.userInfos.sponsorLastname : '',
        '#SMOOTHINCREASE#': (this.$store.state.form.resultJson.starterPack.priceSmoothIncrease !== null) ? this.$t('starterPack.subtitleSmoothIncrease') + ' : <b>' + this.$store.state.form.resultJson.starterPack.priceSmoothIncrease + this.$store.state.config.mainconfig.currency + ' / ' + this.$store.state.config.prices.smoothIncrease.duration + ' ' + this.getPeriodTranslation(this.$store.state.config.prices.smoothIncrease.commitment, this.$store.state.config.prices.smoothIncrease.duration).toLowerCase() + '</b><br />' : '',
        '#INSURANCE#': (this.$store.state.form.resultJson.starterPack.choiceInsurance && this.$store.state.form.resultJson.starterPack.priceInsurance !== null) ? this.$store.state.config.prices.insurance.name + ': <b>' + this.$store.state.form.resultJson.starterPack.priceInsurance + this.$store.state.config.mainconfig.currency + '</b><br />' : '',
        '#EMPLOYEDPACKAGE#': (this.$store.state.form.resultJson.starterPack.pricePackage !== null) ? this.$store.state.config.prices.employedPackages.name + ': <b>' + this.$store.state.form.resultJson.starterPack.pricePackage + this.$store.state.config.mainconfig.currency + ' / ' + this.$store.state.config.prices.employedPackages.duration + ' ' + this.getPeriodTranslation(this.$store.state.config.prices.employedPackages.commitment, this.$store.state.config.prices.employedPackages.duration).toLowerCase() + '</b>' : '',
        '#RECURRENTTIME#': (this.$store.state.form.resultJson.offer.selectedOffer.recurrentTime === 'month') ? 'mois' : (this.$store.state.form.resultJson.offer.selectedOffer.recurrentTime === 'year' ? 'année' : 'semaine')
      };

      // Replace des templates avec les bonnes valeurs
      this.templateContract = TemplateContract.template;
      return this.templateContract.replace(/#NOMJOUEUR#|#PRENOMJOUEUR#|#ADRJOUEUR#|#CPJOUEUR#|#VILLEJOUEUR#|#EMAILJOUEUR#|#TELJOUEUR#|#NOMPRESTA#|#OPTPRESTA#|#DEBUTPRESTA#|#FINPRESTA#|#PRIXPARSEMAINE#|#PRIXIMMEDIAT#|#LISTEOPTIONS#|#NOMCLUB#|#ADRCLUB#|#CPCLUB#|#VILLECLUB#|#CLAUSECLUB#|#LOGOCLUB#|#NOMCOMMERCIAL#|#NOMPARRAIN#|#SMOOTHINCREASE#|#INSURANCE#|#EMPLOYEDPACKAGE#|#RECURRENTTIME#/g, function (matched) {
        return mapDatas[matched];
      });
    },
    formatTemplateAutorisationPrel: function () {
      var mapDatas = {
        '#NOMJOUEUR#': this.$store.state.form.resultJson.finalUserInfos.personal.lastname,
        '#PRENOMJOUEUR#': this.$store.state.form.resultJson.finalUserInfos.personal.firstname,
        '#ADRJOUEUR#': this.$store.state.form.resultJson.finalUserInfos.personal.adress !== null ? this.$store.state.form.resultJson.finalUserInfos.personal.adress : '',
        '#CPJOUEUR#': this.$store.state.form.resultJson.finalUserInfos.personal.postal !== null ? this.$store.state.form.resultJson.finalUserInfos.personal.postal : '',
        '#VILLEJOUEUR#': this.$store.state.form.resultJson.finalUserInfos.personal.city !== null ? this.$store.state.form.resultJson.finalUserInfos.personal.city : '',
        '#NOMCLUB#': this.club.clubName !== null ? this.club.clubName : '',
        '#ADRCLUB#': this.club.adr1 !== null ? this.club.adr1 : '',
        '#CPCLUB#': this.club.postalCode !== null ? this.club.postalCode : '',
        '#ICSCLUB#': this.club.rum !== null ? this.club.rum : '',
        '#VILLECLUB#': this.club.city !== null ? this.club.city : '',
        '#RIBDETENTEUR#': (this.$store.state.form.resultJson.finalUserInfos.bank.bankFirstname !== null && this.$store.state.form.resultJson.finalUserInfos.bank.bankLastname !== null) ? this.$store.state.form.resultJson.finalUserInfos.bank.bankLastname + ' ' + this.$store.state.form.resultJson.finalUserInfos.bank.bankFirstname : '',
        '#RIBIBAN#': (this.$store.state.form.resultJson.finalUserInfos.bank.bankIban !== null) ? this.$store.state.form.resultJson.finalUserInfos.bank.bankIban : '',
        '#RIBBIC#': (this.$store.state.form.resultJson.finalUserInfos.bank.bankBic !== null) ? this.$store.state.form.resultJson.finalUserInfos.bank.bankBic : '',
        // '#CONTRATSEPA#': (this.contratSepa !== null) ? this.contratSepa : '',
        '#RIBRUM#': (this.rum !== null) ? this.rum : ''
      };

      // Replace des templates avec les bonnes valeurs
      this.templateAutorisationPrel = TemplateAutorisationPrel.template;
      return this.templateAutorisationPrel.replace(/#NOMJOUEUR#|#PRENOMJOUEUR#|#ADRJOUEUR#|#CPJOUEUR#|#VILLEJOUEUR#|#NOMCLUB#|#ADRCLUB#|#CPCLUB#|#VILLECLUB#|#ICSCLUB#|#RIBDETENTEUR#|#RIBIBAN#|#CONTRATSEPA#|#RIBRUM#|#RIBBIC#/g, function (matched) {
        return mapDatas[matched];
      });
    },
    createPDF: function (name) {
      this.isPdfRendering = true;
      // eslint-disable-next-line
        this.optHtml2Pdf['filename'] = this.$t(name) + '.pdf'
      // eslint-disable-next-line
        html2pdf(this.formatTemplate(name), this.optHtml2Pdf).then((response) => {
        this.isPdfRendering = false;
      });
    },
    prefillTemplates: async function () {
      let infosCLub = await this.$http.get('zone/' + this.$store.state.form.resultJson.finalUserInfos.subscription.subscriptionClub
      ) // eslint-disable-next-line
          .catch((err) => {
          this.$sentry.captureExceptionWithTags(err, {}, this.$options.name, 'prefillTemplates');
          this.$notify({
            type: 'error',
            title: this.$t('general.errorApi.generalTitle'),
            text: this.$t('general.errorApi.getInfosClub.errormsg')
          });
        });

      if (infosCLub.data.errno !== undefined) {
        this.$notify({type: 'error', title: this.$t('general.errorApi.generalTitle'), text: infosCLub.data.errormsg});
        return;
      }

      // On stocke les infos du club
      this.club = infosCLub.data.response;

      if (this.club.imageclub !== null) {
        let imgBody = await base64Img.requestBase64('http://' + document.location.host + '/' + this.club.imageclub);
        this.club.imageclub = '<img src=\'' + imgBody.data + '\' height=\'50\'';
      }

      let subscriptionClub = await this.$http.get('member/bank/' + -this.$store.state.form.resultJson.finalUserInfos.subscription.subscriptionClub)// eslint-disable-next-line
          .catch((err) => {
          this.$sentry.captureExceptionWithTags(err, {}, this.$options.name, 'prefillTemplates');
          this.$notify({
            type: 'error',
            title: this.$t('general.errorApi.generalTitle'),
            text: this.$t('general.errorApi.getInfosClub.errormsg')
          });
        });
      if (subscriptionClub.data.errno !== undefined) {
        this.$notify({
          type: 'error',
          title: this.$t('general.errorApi.generalTitle'),
          text: subscriptionClub.data.errormsg
        });
      } else {
        this.club.rum = subscriptionClub.data.response.rum;
      }
    },
    saveForm: function () {
      if (this.$parent.$refs.topProgressBar.getProgress() === 0) {
        this.$notify({clean: true});
        this.$store.dispatch('form/FORM_RESET');
      } else {
        this.$notify({
          type: 'error',
          title: this.$t('endStep.uploadDevis.title'),
          text: this.$t('endStep.uploadDevis.notfinished')
        });
      }
    },
    goToCashRegister: function () {
      if (this.idj !== null && !isNaN(this.idj)) {
        const idj = this.idj;
        let url = 'caisse.php?idj=' + idj;
        document.location.href = url;
      }
    },
    generateFileName: function (dataMember, postfix) {
      return dataMember['surname'] + '-' + dataMember['name'] + '-' + convertDate(new Date()) + '-' + postfix;
    },
    uploadContrat: function () {
      this.$parent.$refs.topProgressBar.start();
      this.$notify({
        type: 'info',
        duration: -1,
        title: this.$t('endStep.uploadDevis.title'),
        text: this.$t('endStep.uploadDevis.sending')
      });

      let nameDevis = 'Proposition de contrat ' + this.$store.state.form.resultJson.offer.selectedOffer.name + ' ' + new Date().toISOString().slice(0, 10) + ' - Partner+.pdf';
      let pathDevis = `doc/j${this.idj}/partner+/`;

      this.optHtml2Pdf['filename'] = nameDevis;
      // eslint-disable-next-line
      html2pdf().from(this.formatTemplate(this.contractName)).set(this.optHtml2Pdf).outputPdf('blob').then(pdf => {
        const formData = new FormData();
        formData.append('document', JSON.stringify({path: pathDevis + nameDevis, desciption: nameDevis}));
        formData.append('file', pdf);
        this.$http.put(`member/${this.idj}/document`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        },
        {
          onUploadProgress: (progressEvent) => {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            this.$parent.$refs.topProgressBar.set(percentCompleted);
          }
        }).then((resp) => {
          this.uploadContractSuccessful();
        }).catch(err => {
          this.$sentry.captureExceptionWithTags(err, {}, this.$options.name, 'uploadContrat');
          this.$parent.$refs.topProgressBar.fail();
          this.$notify({
            clean: true
          });
          this.$notify({
            type: 'error',
            duration: -1,
            title: this.$t('general.errorApi.generalTitle'),
            text: this.$t('general.errorApi.uploadDevis.errormsg')
          });
        });
      }).catch(err => {
        this.$sentry.captureExceptionWithTags(err, {}, this.$options.name, 'uploadContrat');
        this.$parent.$refs.topProgressBar.fail();
        this.$notify({
          clean: true
        });
        this.$notify({
          type: 'error',
          duration: -1,
          title: this.$t('general.errorApi.generalTitle'),
          text: this.$t('general.errorApi.uploadDevis.errormsg')
        });
      });
    },
    getPeriodTranslation (period, duration) {
      let translatedPeriod = '';
      switch (period) {
        case 'week':
          translatedPeriod = this.$tc('config.commitments.week', (duration > 1) ? 2 : 1);
          break;
        case 'month':
          translatedPeriod = this.$t('config.commitments.month', (duration > 1) ? 2 : 1);
          break;
        case 'year':
          translatedPeriod = this.$tc('config.commitments.year', (duration > 1) ? 2 : 1);
          break;
      }
      return translatedPeriod;
    },
    // Fonction pour formatter les infos à enregistrer sur le champ info_admin du membre
    formatAdminInfos: function (key, value) {
      return this.$t('endStep.adminInfos.listDelimiter') + key + this.$t('endStep.adminInfos.colon') + value + '\n';
    },
    // Renvoie une chaine listant les éléments d'un tableau en paramètre et la clé i18n permettant d'accéder aux traductions des éléments
    stringifyArray: function (array, i18nKey) {
      let returnArray = [];
      array.forEach((item, index) => {
        returnArray[index] = this.$t(i18nKey + item);
      });
      return returnArray.join(', ');
    },
    uploadContractSuccessful: function () {
      this.$parent.$refs.topProgressBar.done();
      this.$notify({
        clean: true
      });
      this.$notify({
        type: 'success',
        title: this.$t('endStep.uploadDevis.title'),
        text: this.$t('endStep.uploadDevis.success')
      });
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/EndStep.vue